(ns practitest.frontend.tests.test-form.tests-grid
  (:require [practitest.frontend.common-entities :as common-entities]
            [practitest.frontend.common-entities.events :as common-events]
            [practitest.frontend.common.re-frame :refer [build-event-vector
                                                         partial-dispatch
                                                         partial-subscribe]]
            [practitest.frontend.components.grid.events :as grid.events]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [practitest.frontend.events :as events]
            [practitest.frontend.forms3.entity-form.forms :as f3.forms]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.tests.index :as tests-index]
            [practitest.frontend.tests.test-form.common :refer [steps-form-id]]
            [re-frame.core :as re-frame]))

;;; Common code for "tests grid" - used in "Copy Step" and "Call to test" modals 

(def grid-entity-type :test)

;; Now this is quite convoluted and should be cleaned up
;; But the idea is to reuse filters columns definitions in this particular grid
(re-frame/reg-sub
  ::tests-grid-columns
  (fn [[_ form-id]]
    [(re-frame/subscribe [::grid.subs/columns [grid-entity-type :test-columns]])
     (re-frame/subscribe [::tests-index/filter_columns form-id])])
  (fn [[test-columns filter-columns]]
    (map #(assoc % :default-show? true)
         (concat [{:type :display_id
                   :field :display_id
                   :default-width 80
                   :default-show? true
                   :autofilter? true
                   :header "ID"}]
                 (common-entities/grid-columns test-columns filter-columns)))))

(re-frame/reg-sub
  ::tests-grid-data
  (fn [db [_ form-id]]
    (get-in db [:entity grid-entity-type form-id :data])))

;; We have custom selection logic which is not really compatible with common-events implementation
;; so we're overriding this event handler here, although correct way would be to refactor common-events a bit
(re-frame/reg-event-fx
  ::set-current-folder
  (fn [{db :db} [_ {:keys [form-id reset-selection-event]} & args]]
    {:dispatch-n [(apply build-event-vector
                         [::common-events/set-current-folder grid-entity-type form-id ::common-events/fetch-entity-list-by-folder]
                         args)
                  reset-selection-event]}))

;; same here for filters event
(re-frame/reg-event-fx
  ::set-current-filter
  (fn [{db :db} [_ {:keys [form-id
                           reset-selection-event]}
                 & args]]
    {:dispatch-n [(apply build-event-vector
                         [::common-events/set-current-filter grid-entity-type form-id ::common-events/fetch-entity-list]
                         args)
                  reset-selection-event]}))

(defn default-grid-props
  [form-id reset-selection-event grid-state]
  {:show-views? (re-frame/subscribe [::grid.subs/link-entities-show-views? grid-entity-type form-id])
   :current-filter-selected (re-frame/subscribe [::grid.subs/link-entities-current-filter-selected grid-entity-type form-id])
   :set-current-filter (partial-dispatch [::set-current-filter {:form-id form-id
                                                                :reset-selection-event reset-selection-event}])
   :set-current-folder (partial-dispatch [::set-current-folder {:form-id form-id
                                                                :reset-selection-event reset-selection-event}])
   ;; default selection behavior
   :selected? (partial-subscribe [::grid.subs/selected? [grid-entity-type form-id]])
   :all-selected? (partial-subscribe [::grid.subs/all-selected? [grid-entity-type form-id]])
   :selection @(re-frame/subscribe [::grid.subs/selection [grid-entity-type form-id]])
   :on-filter-changed (partial-dispatch [::grid.events/clear-selection [grid-entity-type form-id]])
   :grid-state grid-state
   :local-state-updating grid-state
   :loading? (re-frame/subscribe [::subs/progress? ::common-events/fetch-entity-list])
   :module "Test"
   :table-id (str (:id @(re-frame/subscribe [::subs/current-project]))
                  (str form-id))
   :data (re-frame/subscribe [::tests-grid-data form-id])
   :columns (re-frame/subscribe [::tests-grid-columns form-id])
   :on-query-changed (partial-dispatch [::common-events/fetch-entity-list grid-entity-type form-id])
   :current-page (re-frame/subscribe [::grid.subs/entities-current-page grid-entity-type form-id])
   :total-count (re-frame/subscribe [::grid.subs/entities-total-count grid-entity-type form-id])
   :get-field-props (partial-subscribe [::f3.forms/field-props grid-entity-type])
   :full-data? (re-frame/subscribe [::grid.subs/entities-full-data? grid-entity-type form-id])})

;;; Expandable step rows - shared by Copy Steps and Call to Test modals

(re-frame/reg-sub
  ::expandable-row?
  (fn [_ [_ {:keys [steps_count]}]]
    (and (number? steps_count) (pos? steps_count))))

(re-frame/reg-sub
  ::expanded-row?
  (fn [db [_ form-id test-row]]
    (contains? (get-in db [:form-states2 steps-form-id form-id :expanded-tests]) (:id test-row))))

(re-frame/reg-sub
  ::steps-data
  (fn [db [_ form-id test-id]]
    (sort-by :position (get-in db [:form-states2 steps-form-id form-id :steps-data test-id]))))

(re-frame/reg-event-fx
  ::on-expand-data-error
  (fn [{db :db} [_ form-id test-id]]
    {:db (update-in db [:form-states2 steps-form-id form-id :expanded-tests] disj test-id)
     :dispatch [::events/api-error [::fetch-step-data form-id test-id]
                {:message "Error fetching test steps"}]}))

